import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function getVid() {
  let v = localStorage.getItem("cocoon_vid");
  if (!v) {
    v = window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("cocoon_vid", v);
  }
  return v;
}

// Privacy-friendly, anonymous, cookie-less visit tracking. Fires on route change.
// Excludes admin routes and admin accounts so owner activity doesn't skew stats.
export function VisitTracker() {
  const location = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    const path = location.pathname || "/";
    if (path.startsWith("/admin")) return;
    if (user?.role === "admin") return;
    const id = setTimeout(() => {
      api
        .post("/track/visit", {
          path,
          referrer: document.referrer || null,
          lang: (localStorage.getItem("i18nextLng") || navigator.language || "").slice(0, 2),
          vid: getVid(),
        })
        .catch(() => {});
    }, 400);
    return () => clearTimeout(id);
  }, [location.pathname, user]);
  return null;
}
